// extracted by mini-css-extract-plugin
export default {"container":"style_container__84VxH","links":"style_links__dp5bf","notice":"style_notice__sCnUL"};